// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateFundraiser_container__kxlsp{
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 40px;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.CreateFundraiser_topSection__ApccJ{
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 1224px;
}
.CreateFundraiser_header__LRmth{
    text-align: left;
}
.CreateFundraiser_organizationContainer__IJIUf{
    display: flex;
    margin-left: auto;
}
@media(max-width: 1370px){
    .CreateFundraiser_topSection__ApccJ{
        flex-direction: column;
        width: 725px;
        margin-bottom: 20px;
    }
    .CreateFundraiser_header__LRmth{
        margin-bottom: 18px;
        text-align: center;
    }
    .CreateFundraiser_organizationContainer__IJIUf{
        margin-left: 0;
    }
}
@media(max-width: 862px){
    .CreateFundraiser_topSection__ApccJ{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .CreateFundraiser_topSection__ApccJ{
        width: calc(100% - 40px);
    }
}
.CreateFundraiser_organization__qMRmH{
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 22px;
    margin-left: auto;
    padding: 10px 20px;
    color: #40798C;
    background-color: #70A9A11A;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    border-radius: 25px;
}
@media(max-width: 862px){
    .CreateFundraiser_organization__qMRmH{
        text-align: center;
        line-height: 16px;
    }
}
.CreateFundraiser_middleSection__NRNiA{
    display: flex;
    justify-content: center;
}
.CreateFundraiser_leftSide__Ruho5{
    width: 500px;
}
@media(max-width: 1370px){
    .CreateFundraiser_middleSection__NRNiA{
        align-items: center;
        flex-direction: column;
    }
    .CreateFundraiser_leftSide__Ruho5{
        width: 725px;
    }
}
@media(max-width: 862px){
    .CreateFundraiser_leftSide__Ruho5{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .CreateFundraiser_leftSide__Ruho5{
        width: calc(100% - 40px);
    }
}
.CreateFundraiser_singleLineInput__1gWeF, .CreateFundraiser_singleLineCheckbox__jAEG6, .CreateFundraiser_singleLineDropdown__\\+Jv-t, .CreateFundraiser_singleLineMoneyInput__s\\+rG3{
    display: block !important;
    margin-top: 15px;
}
.CreateFundraiser_singleLineInput__1gWeF input{
    width: calc(100% - 44px);
}
.CreateFundraiser_singleLineCheckbox__jAEG6{
    margin-left: 6px;
}
.CreateFundraiser_singleLineDropdown__\\+Jv-t select{
    width: 100%;
}
.CreateFundraiser_singleLineMoneyInput__s\\+rG3 input{
    width: calc(100% - 80px);
}
.CreateFundraiser_singleLineTextEditor__wbHOp{
    display: block !important;
    height: calc(100% - 34px);
    margin-top: 20px;
}
@media(max-width: 1370px){
    .CreateFundraiser_singleLineTextEditor__wbHOp{
        margin-top: 15px;
    }
}
.CreateFundraiser_singleLineTextEditor__wbHOp textarea{
    width: calc(100% - 48px);
}
.CreateFundraiser_startTimeRow__xA3\\+F{
    display: flex;
    margin-top: 15px;
}
.CreateFundraiser_startTime__e0Z\\+I select{
    width: 242px;
}
@media(max-width: 1370px){
    .CreateFundraiser_startTime__e0Z\\+I select{
        width: 354px;
    }
}
@media(max-width: 862px){
    .CreateFundraiser_startTime__e0Z\\+I{
        width: calc(50% - 10px);
    }
    .CreateFundraiser_startTime__e0Z\\+I select{
        width: 100%;
    }
}
@media(max-width: 680px){
    .CreateFundraiser_startTimeRow__xA3\\+F{
        flex-direction: column;
    }
    .CreateFundraiser_startTime__e0Z\\+I{
        width: 100%;
    }
    .CreateFundraiser_startTime__e0Z\\+I:first-child{
        margin-bottom: 15px;
    }
}
.CreateFundraiser_requestDirectPaymentText__-4Ftf{
    display: flex;
    margin-top: 10px;
    margin-bottom: 25px;
    padding: 12px;
    color: #1F363D;
    background-color: #70A9A11A;
    font-size: 12px;
    line-height: 140%;
    border: 1px solid #70A9A11A;
    border-radius: 8px;
}
.CreateFundraiser_exclamationCircle__fTHE2{
    height: 17px;
    width: 17px;
    margin-right: 10px;
}
.CreateFundraiser_rightSide__TjbN8{
    width: 694px;
    margin-left: 30px;
}
@media(max-width: 1370px){
    .CreateFundraiser_rightSide__TjbN8{
        height: 378px;
        width: 725px;
        margin-left: 0;
        padding-top: 0;
    }
}
@media(max-width: 862px){
    .CreateFundraiser_rightSide__TjbN8{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .CreateFundraiser_rightSide__TjbN8{
        width: calc(100% - 40px);
    }
}
.CreateFundraiser_bottomSection__4bqnq{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 45px;
    margin-bottom: 20px;
}
@media(max-width: 1370px){
    .CreateFundraiser_bottomSection__4bqnq{
        margin-top: 35px;
        margin-bottom: 15px;
    }
}
.CreateFundraiser_apiError__hPqGn{
    margin-top: -15px;
    margin-bottom: 20px;
}
.CreateFundraiser_button__qba2h{
    width: 200px;
    padding-left: 100px;
    padding-right: 100px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CreateFundraiser.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,mBAAmB;AACvB;AACA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI;QACI,aAAa;QACb,YAAY;QACZ,cAAc;QACd,cAAc;IAClB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".container{\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 40px;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.topSection{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 1224px;\n}\n.header{\n    text-align: left;\n}\n.organizationContainer{\n    display: flex;\n    margin-left: auto;\n}\n@media(max-width: 1370px){\n    .topSection{\n        flex-direction: column;\n        width: 725px;\n        margin-bottom: 20px;\n    }\n    .header{\n        margin-bottom: 18px;\n        text-align: center;\n    }\n    .organizationContainer{\n        margin-left: 0;\n    }\n}\n@media(max-width: 862px){\n    .topSection{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .topSection{\n        width: calc(100% - 40px);\n    }\n}\n.organization{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 22px;\n    margin-left: auto;\n    padding: 10px 20px;\n    color: #40798C;\n    background-color: #70A9A11A;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    border-radius: 25px;\n}\n@media(max-width: 862px){\n    .organization{\n        text-align: center;\n        line-height: 16px;\n    }\n}\n.middleSection{\n    display: flex;\n    justify-content: center;\n}\n.leftSide{\n    width: 500px;\n}\n@media(max-width: 1370px){\n    .middleSection{\n        align-items: center;\n        flex-direction: column;\n    }\n    .leftSide{\n        width: 725px;\n    }\n}\n@media(max-width: 862px){\n    .leftSide{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .leftSide{\n        width: calc(100% - 40px);\n    }\n}\n.singleLineInput, .singleLineCheckbox, .singleLineDropdown, .singleLineMoneyInput{\n    display: block !important;\n    margin-top: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 44px);\n}\n.singleLineCheckbox{\n    margin-left: 6px;\n}\n.singleLineDropdown select{\n    width: 100%;\n}\n.singleLineMoneyInput input{\n    width: calc(100% - 80px);\n}\n.singleLineTextEditor{\n    display: block !important;\n    height: calc(100% - 34px);\n    margin-top: 20px;\n}\n@media(max-width: 1370px){\n    .singleLineTextEditor{\n        margin-top: 15px;\n    }\n}\n.singleLineTextEditor textarea{\n    width: calc(100% - 48px);\n}\n.startTimeRow{\n    display: flex;\n    margin-top: 15px;\n}\n.startTime select{\n    width: 242px;\n}\n@media(max-width: 1370px){\n    .startTime select{\n        width: 354px;\n    }\n}\n@media(max-width: 862px){\n    .startTime{\n        width: calc(50% - 10px);\n    }\n    .startTime select{\n        width: 100%;\n    }\n}\n@media(max-width: 680px){\n    .startTimeRow{\n        flex-direction: column;\n    }\n    .startTime{\n        width: 100%;\n    }\n    .startTime:first-child{\n        margin-bottom: 15px;\n    }\n}\n.requestDirectPaymentText{\n    display: flex;\n    margin-top: 10px;\n    margin-bottom: 25px;\n    padding: 12px;\n    color: #1F363D;\n    background-color: #70A9A11A;\n    font-size: 12px;\n    line-height: 140%;\n    border: 1px solid #70A9A11A;\n    border-radius: 8px;\n}\n.exclamationCircle{\n    height: 17px;\n    width: 17px;\n    margin-right: 10px;\n}\n.rightSide{\n    width: 694px;\n    margin-left: 30px;\n}\n@media(max-width: 1370px){\n    .rightSide{\n        height: 378px;\n        width: 725px;\n        margin-left: 0;\n        padding-top: 0;\n    }\n}\n@media(max-width: 862px){\n    .rightSide{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .rightSide{\n        width: calc(100% - 40px);\n    }\n}\n.bottomSection{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 45px;\n    margin-bottom: 20px;\n}\n@media(max-width: 1370px){\n    .bottomSection{\n        margin-top: 35px;\n        margin-bottom: 15px;\n    }\n}\n.apiError{\n    margin-top: -15px;\n    margin-bottom: 20px;\n}\n.button{\n    width: 200px;\n    padding-left: 100px;\n    padding-right: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateFundraiser_container__kxlsp`,
	"topSection": `CreateFundraiser_topSection__ApccJ`,
	"header": `CreateFundraiser_header__LRmth`,
	"organizationContainer": `CreateFundraiser_organizationContainer__IJIUf`,
	"organization": `CreateFundraiser_organization__qMRmH`,
	"middleSection": `CreateFundraiser_middleSection__NRNiA`,
	"leftSide": `CreateFundraiser_leftSide__Ruho5`,
	"singleLineInput": `CreateFundraiser_singleLineInput__1gWeF`,
	"singleLineCheckbox": `CreateFundraiser_singleLineCheckbox__jAEG6`,
	"singleLineDropdown": `CreateFundraiser_singleLineDropdown__+Jv-t`,
	"singleLineMoneyInput": `CreateFundraiser_singleLineMoneyInput__s+rG3`,
	"singleLineTextEditor": `CreateFundraiser_singleLineTextEditor__wbHOp`,
	"startTimeRow": `CreateFundraiser_startTimeRow__xA3+F`,
	"startTime": `CreateFundraiser_startTime__e0Z+I`,
	"requestDirectPaymentText": `CreateFundraiser_requestDirectPaymentText__-4Ftf`,
	"exclamationCircle": `CreateFundraiser_exclamationCircle__fTHE2`,
	"rightSide": `CreateFundraiser_rightSide__TjbN8`,
	"bottomSection": `CreateFundraiser_bottomSection__4bqnq`,
	"apiError": `CreateFundraiser_apiError__hPqGn`,
	"button": `CreateFundraiser_button__qba2h`
};
export default ___CSS_LOADER_EXPORT___;
